import 'slick-carousel';
import 'slick-carousel/slick/slick.css'; // 追加
import 'slick-carousel/slick/slick-theme.css'; // 追加

$(function(){
  if ($('.p-employee-slide__items').length > 0) {
    $(".p-employee-slide__items").slick({
      // autoplay:true,
      slidesToShow:5,
      arrows: false,
      infinite:true,
      slidesToScroll:1,
      responsive: [
        {
          breakpoint: 769, // 768px以下のサイズに適用
            settings: {
            // autoplay:true,
            slidesToShow:1,
            arrows: false,
            infinite:true,
            slidesToScroll:1,
            centerMode:true,
            centerPadding:"20%",
          },
        },
      ],
    });

  $('.p-employee-slide__arrow--right').on('click', function() {
    $(".p-employee-slide__items").slick('slickNext');
  });

  $('.p-employee-slide__arrow--left').on('click', function() {
    $(".p-employee-slide__items").slick('slickPrev');
  });
  }

  if ($('.p-project-slide__items').length > 0 || $('.p-3-minutes__slide--sp').length > 0) {
    $(".p-project-slide__items").slick({
      // autoplay:true,
      slidesToShow:1,
      arrows: false,
      infinite:true,
      slidesToScroll:1,
    });

    $(".p-3-minutes__slide--sp").slick({
      // autoplay:true,
      slidesToShow:1,
      arrows: false,
      infinite:true,
      slidesToScroll:1,
    });

  $('.p-3-minutes__slide__container__arrow--right').on('click', function() {
    $(".p-3-minutes__slide--sp").slick('slickNext');
  });

  $('.p-3-minutes__slide__container__arrow--left').on('click', function() {
    $(".p-3-minutes__slide--sp").slick('slickPrev');
  });

  $('.p-project-slide__arrow--right').on('click', function() {
    $(".p-project-slide__items").slick('slickNext');
  });

  $('.p-project-slide__arrow--left').on('click', function() {
    $(".p-project-slide__items").slick('slickPrev');
  });
  }

  if ($('.p-burger__btn').length > 0) {
  $(".p-burger__btn").on('click', function() {
    $(this).toggleClass('active');
    $(".p-burger").toggleClass('active');
    $(".l-body").toggleClass('active');
    $(".c-company-logo--burger").toggleClass('active');
    $(".c-company-logo--usually").toggleClass('active');
    $(".p-recruit-list").toggleClass('active');
  });

  $(".p-burger__list").on('click', function() {
    $(this).toggleClass('active');
  });

  $(".p-welfare__list").on('click', function() {
    $(this).toggleClass('active');
  });
}

  if ($('.p-recruit-list').length > 0) {
  $(".p-recruit-list").on({
    "mouseenter": function(){$(".p-recruit-list__container").addClass('active');},
    "mouseleave": function(){$(".p-recruit-list__container").removeClass('active');}
    });
  }

    let scrollend = $('#footer').offset().top; //ページ上部からの距離を取得
    let distance = 0;
    let wh = $(window).height();
    if ($('.p-recruit-list').length > 0) {
    $(document).on('scroll', function(){
      distance = $(this).scrollTop(); //スクロールした距離を取得
      scrollend = $('#footer').offset().top;
      wh = $(window).height();
      if (scrollend - wh <= distance) {
        $('.p-recruit-list').addClass('hidden');
      } else{
        $('.p-recruit-list').removeClass('hidden');
      }
    });
  }
      let scrollTop = 0;
      if ($('.1988').length > 0) {
        let areaTop1 = $('.1988').position().top;
        let areaTop2 = $('.2024').position().top;
        $(".p-scroll-box__list").on('scroll', function(){
            scrollTop = $(".p-scroll-box__list").scrollTop();
            if (scrollTop + 810 > areaTop1) {
              $('.img-1').addClass('none');
              $('.img-3').addClass('none');
              $('.img-2').removeClass('none');
            } else{
              $('.img-2').addClass('none');
              $('.img-3').addClass('none');
              $('.img-1').removeClass('none');
            }
            if (scrollTop + 810 > areaTop2) {
              $('.img-1').addClass('none');
              $('.img-2').addClass('none');
              $('.img-3').removeClass('none');
            }
        });
      }

      if ($('#first-half__btn').length > 0) {
      $("#first-half__btn").on('click', function() {
        $(".p-100-questions__btn--first-half").addClass('active');
        $(".p-100-questions__btn--latter-half").removeClass('active');
        $(".p-100-questions__container--latter-half").addClass('none');
        $(".p-100-questions__container--first-half").removeClass('none');
        $(".p-100-questions__container--latter-bottom").addClass('none');
        $(".p-100-questions__container--first-bottom").removeClass('none');
      });

      $("#latter-half__btn").on('click', function() {
        $(".p-100-questions__btn--latter-half").addClass('active');
        $(".p-100-questions__btn--first-half").removeClass('active');
        $(".p-100-questions__container--latter-half").removeClass('none');
        $(".p-100-questions__container--first-half").addClass('none');
        $(".p-100-questions__container--latter-bottom").removeClass('none');
        $(".p-100-questions__container--first-bottom").addClass('none');
      });

      $("#first-half__btn--bottom").on('click', function() {
        $(".p-100-questions__btn--latter-half").addClass('active');
        $(".p-100-questions__btn--first-half").removeClass('active');
        $(".p-100-questions__container--latter-half").toggleClass('none');
        $(".p-100-questions__container--first-half").toggleClass('none');
        $(".p-100-questions__container--latter-bottom").toggleClass('none');
        $(".p-100-questions__container--first-bottom").toggleClass('none');
      });

      $("#latter-half__btn--bottom").on('click', function() {
        $(".p-100-questions__btn--first-half").addClass('active');
        $(".p-100-questions__btn--latter-half").removeClass('active');
        $(".p-100-questions__container--latter-half").toggleClass('none');
        $(".p-100-questions__container--first-half").toggleClass('none');
        $(".p-100-questions__container--latter-bottom").toggleClass('none');
        $(".p-100-questions__container--first-bottom").toggleClass('none');
      });
    }

});

    $(function(){
        // モーダルを取得
        const modal = document.getElementById("modal");
        // モーダルを表示するボタンを全て取得
        const openModalBtns = document.querySelectorAll(".js-open-modal");
        // モーダルを閉じるボタンを全て取得
        const closeModalBtns = document.querySelectorAll(".js-close-modal");

        // slickの設定
        if ($('.slick-wrapper').length > 0) {
        $(".slick-wrapper").slick({
          // autoplay:true,
          slidesToShow:1,
          arrows: false,
          infinite:true,
          slidesToScroll:1,
          adaptiveHeight: true,
        });

        $('.p-modal__slick-button-prev').on('click', function() {
          $(".slick-wrapper").slick('slickNext');
        });

        $('.p-modal--9-data__link').on('click', function() {
          $(".slick-wrapper").slick('slickNext');
        });

        $('.p-modal__slick-button-next').on('click', function() {
          $(".slick-wrapper").slick('slickPrev');
        });

        // モーダルを表示するボタンをクリックしたとき
        openModalBtns.forEach((openModalBtn) => {
          openModalBtn.addEventListener("click", () => {
            // data-slide-indexに設定したスライド番号を取得
            const modalIndex = parseInt(openModalBtn.dataset.slideIndex) - 1;
          $('.slick-wrapper').slick("slickGoTo", modalIndex, false);
            modal.classList.add("is-active");
          });
        });
      }
        // モーダルを閉じるボタンをクリックしたとき
        closeModalBtns.forEach((closeModalBtn) => {
          closeModalBtn.addEventListener("click", () => {
            modal.classList.remove("is-active");
          });
        });
        if ($('#player').length > 0) {
          // モーダルを表示するボタンをクリックしたとき
        openModalBtns.forEach((openModalBtn) => {
          openModalBtn.addEventListener("click", () => {
          $("#player").get(0).play();
            modal.classList.add("is-active");
          });
        });

        // モーダルを閉じるボタンをクリックしたとき
        closeModalBtns.forEach((closeModalBtn) => {
          closeModalBtn.addEventListener("click", () => {

            $("#player").get(0).pause();

            modal.classList.remove("is-active");
          });
        });
      }
        //下からふわっと
        if ($('.u-fade').length > 0) {
        const targets = document.getElementsByClassName('u-fade');
        for(let i = targets.length; i--;){
        let observer = new IntersectionObserver((entries, observer) => {
          for(let j = entries.length; j--;){
          if (entries[j].isIntersecting) {
            entries[j].target.classList.add('active');
            observer.unobserve(entries[j].target);
          }
          }
        });
        observer.observe(targets[i]);
        }
      }

     $("#person-btn").on('click', function() {
        $(".p-person-card").addClass('d-none');
        const jobarray = [];
        const jobelements = document.querySelectorAll(".jobcheckbox");
        jobelements.forEach((jobelement) => {
          if ( jobelement.checked ){
            var jobNameTentative = $(jobelement).attr('name');
            var jobName = '.is-' + jobNameTentative;
            jobarray.push(jobName);
          }
        });

     const detailarray = [];
     var detailelements = document.querySelectorAll(".detailcheckbox");
     detailelements.forEach((detailelement) => {
       if ( detailelement.checked ){
         var detailNameTentative = $(detailelement).attr('name');
         var detailName = '.' + detailNameTentative;
         detailarray.push(detailName);
       }
     });

    if(jobarray.length === 0) {
     jobarray[0] = "";
    }
    if(detailarray.length === 0) {
      detailarray[0] = "";
    }

    let count = 0;
    let detailStr = detailarray.join('');
    for (let i = 0; i < jobarray.length; i++) {
      $(".p-person-card" + jobarray[i] + detailStr).removeClass("d-none");
      count += $(".p-person-card" + jobarray[i] + detailStr).length;
    }
    if(count === 0) {
      $("#notice").removeClass("d-none");
    } else {
      $("#notice").addClass("d-none");
    }
  });


  $("#uncheck-btn").on('click', function() {
    let undetailchecks = document.querySelectorAll(".detailcheckbox");
    undetailchecks.forEach((undetailcheck) => {
    undetailcheck.checked = false;
  });
    let unjobchecks = document.querySelectorAll(".jobcheckbox");
    unjobchecks.forEach((unjobcheck) => {
    unjobcheck.checked = false;
  });
  });

  });



